import React from "react";
import { RiTimerFlashLine } from "react-icons/ri";



export default function TimeInteractive() {
    return (
        <div className="speed-interactive-container">
          <div className="speed-interactive-icon" style={{background:'#FF4B33'}}><RiTimerFlashLine size={42} fill="#fff" /></div>
        </div>
    );
}